import { MyCanonSnrComponent } from "./MyCanonSnrComponent";

export function MyCanonSnrScreen() {
  return (
    <>
      <MyCanonSnrComponent />
    </>
  );
}
